import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from 'src/components/loading-screen';
import MainDashboardLayout from 'src/layouts/dashboard/main-layout';
import TradeWorkTitlePage from 'src/pages/trade-work-title';
export const TradeWorkTitleRoutes = [
    {
        path: '/trade-work-title' ,
        element: (
            <MainDashboardLayout>
                <Suspense fallback={ <LoadingScreen /> }>
                    <Outlet />
                </Suspense>
            </MainDashboardLayout>
        ),
        children: [
            {
                element: <TradeWorkTitlePage />,
                index: true, 
            },
          
        ],
    },
];
